module.exports = __webpack_public_path__ + "static/media/headlight-dark.63f8209c.png";